import { decodeHTMLEntities } from './string.util';

/**
 * Obtiene las iniciales para mostrar en el avatar: primera letra del nombre
 * y primera letra del primer apellido (o segunda palabra del nombre completo).
 * @param nombre Nombre completo, p. ej. "Juan Pérez" o "María González López"
 * @returns Dos letras en mayúscula, p. ej. "JP" o "MG"
 */
export function getIniciales(nombre: string | null | undefined): string {
  if (!nombre || typeof nombre !== 'string') {
    return '';
  }
  const nombreDecodificado = decodeHTMLEntities(nombre);
  const partes = nombreDecodificado.trim().split(/\s+/).filter(Boolean);
  if (partes.length === 0) return '';
  const inicialNombre = partes[0][0] ?? '';
  const inicialApellido = partes.length > 1 ? (partes[1][0] ?? '') : inicialNombre;
  return (inicialNombre + inicialApellido).toUpperCase();
}

